<template>
  <span
    v-if="isVisible"
    v-click-outside="handleClickOutside"
    class="
      sf-level-small sf-markdown-actions sf-nowrap
      live-input-actions__container
      tw-group
    "
    data-behavior="handler"
    data-testid="live-input-action-row"
    :style="styleOffset"
    @mouseenter="handleOuterMouseEnter"
    @mouseleave="handleOuterMouseLeave"
  >
    <LiveInputAction
      v-for="{
        icon,
        iconPath,
        iconContainerClasses,
        variant,
        tooltip,
        shouldPublishHoverEvents,
        testId,
      } in iconsToRender"
      :key="icon"
      :data-testid="testId"
      :icon="icon"
      :icon-path="iconPath"
      :icon-container-classes="iconContainerClasses"
      :variant="variant"
      :tooltip="tooltip"
      :should-publish-hover-events="shouldPublishHoverEvents"
      @click="handleClick"
      @mouseenter="handleMouseEnter"
      @mouseleave="handleMouseLeave"
    />
  </span>
</template>

<script>
import {
  liveInputActionIcons,
  liveInputActionContainer,
  liveInputEvents,
} from '../constants'
import LiveInputAction from './live-input-action.vue'

export default {
  name: 'LiveInputActionRow',
  components: {
    LiveInputAction,
  },
  data: () => ({
    elementLeft: 0,
    elementTop: 0,
    hasCommentIcon: false,
    hasTrashIcon: false,
    hasUndoIcon: false,
    hasInsightsIcon: false,
    isVisible: false,
  }),
  computed: {
    iconsToRender() {
      return [
        {
          variant: 'danger',
          icon: liveInputActionIcons.TRASH,
          isVisible: this.hasTrashIcon,
          shouldPublishHoverEvents: true,
          testId: 'live-input-action-icon-trash-o',
        },
        {
          variant: 'dark',
          icon: liveInputActionIcons.UNDO,
          isVisible: this.hasUndoIcon,
          testId: 'live-input-action-icon-undo',
        },
        {
          variant: 'white',
          icon: liveInputActionIcons.COMMENT,
          isVisible: this.hasCommentIcon,
          testId: 'live-input-action-icon-comment',
        },
        {
          variant: 'white',
          icon: liveInputActionIcons.INSIGHTS,
          iconPath: 'icon-live-input-action-insights.svg',
          iconContainerClasses: '!tw-opacity-30 group-hover:!tw-opacity-80',
          isVisible: this.hasInsightsIcon,
          tooltip: I18n.t('js.live_inputs.tooltips.insights'),
          testId: 'live-input-action-icon-insights-from-file-path',
        },
      ].reduce(
        (
          acc,
          {
            icon,
            iconPath,
            iconContainerClasses,
            isVisible,
            variant,
            tooltip,
            shouldPublishHoverEvents,
            testId,
          }
        ) => {
          if (isVisible) {
            acc.push({
              icon,
              iconPath,
              iconContainerClasses,
              variant,
              tooltip,
              shouldPublishHoverEvents,
              testId,
            })
          }

          return acc
        },
        []
      )
    },
    styleOffset() {
      return {
        left: `${this.elementLeft}px`,
        top: `${this.elementTop}px`,
      }
    },
  },
  created() {
    window.eventHub.$on(liveInputEvents.SHOW_ACTIONS, this.initialise)
    window.eventHub.$on(liveInputEvents.HIDE_ACTIONS, this.hide)
  },
  beforeUnmount() {
    window.eventHub.$off(liveInputEvents.SHOW_ACTIONS, this.initialise)
    window.eventHub.$off(liveInputEvents.HIDE_ACTIONS, this.hide)
  },
  methods: {
    initialise({
      left,
      top,
      hasCommentIcon,
      hasTrashIcon,
      hasUndoIcon,
      hasInsightsIcon,
    } = {}) {
      this.elementLeft = left
      this.elementTop = top
      this.hasCommentIcon = hasCommentIcon
      this.hasTrashIcon = hasTrashIcon
      this.hasUndoIcon = hasUndoIcon
      this.hasInsightsIcon = hasInsightsIcon

      this.show()
    },
    handleClick(icon) {
      window.eventHub.$emit(liveInputEvents.ACTION_CLICKED, icon)
    },
    handleClickOutside(e) {
      window.eventHub.$emit(liveInputEvents.CLICKED_OUTSIDE_ACTIONS, e)
    },
    handleMouseEnter(icon) {
      window.eventHub.$emit(liveInputEvents.MOUSE_ENTERED_ACTION, icon)
    },
    handleMouseLeave(icon) {
      window.eventHub.$emit(liveInputEvents.MOUSE_LEFT_ACTION, icon)
    },
    handleOuterMouseEnter() {
      this.handleMouseEnter(liveInputActionContainer)
    },
    handleOuterMouseLeave() {
      this.handleMouseLeave(liveInputActionContainer)
    },
    hide() {
      this.isVisible = false
    },
    show() {
      this.isVisible = true
    },
  },
}
</script>

<style scoped lang="scss">
.live-input-actions {
  &__container {
    position: fixed;
    padding: 0 0 5px 5px;
  }
}
</style>
